import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexRow)`
    width: 100%;
    padding: 24px;
    gap: 24px;
    box-sizing: border-box;
`;

export const ChartContainer = styled.div`
    width: 100%;
`;
